module.exports = __webpack_public_path__ + "img/L-top.4c566fa7.svg";